__turbopack_context__.v({
  "aside": "index-module__r_r1sa__aside",
  "content": "index-module__r_r1sa__content",
  "desktopBackButton": "index-module__r_r1sa__desktopBackButton",
  "desktopHint": "index-module__r_r1sa__desktopHint",
  "fullScreen": "index-module__r_r1sa__fullScreen",
  "loading": "index-module__r_r1sa__loading",
  "loadingView": "index-module__r_r1sa__loadingView",
  "main": "index-module__r_r1sa__main",
  "mobileButtonGroup": "index-module__r_r1sa__mobileButtonGroup",
  "mobileHeader": "index-module__r_r1sa__mobileHeader",
  "paper": "index-module__r_r1sa__paper",
  "root": "index-module__r_r1sa__root",
  "viewport": "index-module__r_r1sa__viewport",
});
